/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentsReportView {
  ELECTION_SUBMITTED = 'ELECTION_SUBMITTED',
  CARRIER_APPLICATION_SENT = 'CARRIER_APPLICATION_SENT',
  PENDING_CARRIER_CONFIRMATION = 'PENDING_CARRIER_CONFIRMATION',
  PENDING_PAYMENT_CONFIRMATION = 'PENDING_PAYMENT_CONFIRMATION',
  ENROLLMENT_TEAM_ENROLLMENTS = 'ENROLLMENT_TEAM_ENROLLMENTS',
  ALL_ENROLLMENTS = 'ALL_ENROLLMENTS',
  SPECIAL_AGENTS_ENROLLMENTS = 'SPECIAL_AGENTS_ENROLLMENTS',
}
